import mykhailoPhoto from "@assets/image_1773345523383.png";
import { useSEO } from "@/hooks/use-seo";
import { PaymentLogoPill } from "@/components/PaymentLogoPill";
import { useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import {
  ArrowRight, Star, CheckCircle, XCircle, ShieldCheck, Gamepad2,
  HeadphonesIcon, Info, Heart, CreditCard, ChevronDown, ChevronUp,
  Clock, Mail, MessageCircle, Globe, Calendar, Lock,
  Users, Trophy, Zap, Smartphone
} from "lucide-react";
import { Button } from "@/components/ui/button";
import logo4 from "@assets/logos_extracted/4.png";
import { CasinoBreadcrumb } from "@/components/CasinoBreadcrumb";
import { DalsiRecenze } from "@/components/DalsiRecenze";

const CASINO_URL = "https://bsbt.fynkelto.com/?mid=279656_1645822";

const tabs = [
  { id: "platby",     label: "Platby",              icon: CreditCard },
  { id: "hry",        label: "Hry",                 icon: Gamepad2 },
  { id: "podpora",    label: "Zákaznická podpora",  icon: HeadphonesIcon },
  { id: "obecne",     label: "Obecné informace",    icon: Info },
  { id: "zodpovedne", label: "Zodpovědné hraní",    icon: Heart },
];

const depositMethods = [
  "PlayID", "Mastercard", "Paysafecard", "Skrill", "Nuvei",
  "Neteller", "Jetonbank", "MiFinity", "USDTether TRC20",
  "USDTether ERC20", "USDTether BEP20", "Bitcoin", "Ethereum",
  "Litecoin", "Solana", "BNB", "Ripple", "Bitcoin Cash",
  "Dogecoin", "Cardano",
];

const withdrawalMethods = [
  "PlayID", "Visa", "Mastercard", "Bank Transfer", "Revolut",
  "Skrill", "Nuvei", "Neteller", "Jetonbank", "MiFinity",
  "USDTether TRC20", "USDTether ERC20", "USDTether BEP20",
  "Bitcoin", "Ethereum", "Litecoin", "Solana", "BNB",
  "Ripple", "Bitcoin Cash", "Dogecoin", "Cardano",
];

const providers = "1x2Gaming, 2By2, 3 Oaks Gaming, All41 Studios, Amatic, Amusnet, Apollo Games, Apparat, Arcadem, Atmosfera, Bally Wulff, Belatra, BetGamesTV, Betin, Betsoft, Betsolutions, BF Games, BGaming, Big Time Gaming, Bombay Live, Booming, Caleta, Candlebets, Casino Technology, Claw, ElaGames, ELK, Elysium, Endorphina, Evolution, Evoplay, Ezugi, Fantasma, Fazi, FBM, Felix Gaming, Felt Gaming, Foxium, Fugaso, G.Games, GameArt, GameBeat, Gameburger Studios, Games Global, Gaming Corps, Gaming Realms, Gamomat, Gamzix, Givme, Golden Hero Group, Golden Rock Studios, Habanero, Hacksaw Gaming, High5, IGTech, Iron Dog, JFTW, KAGaming, Kajot, Kalamba, Kiron, Leap, Lucky Streak, Mascot, Merkur, Microgaming, MrSlotty, NetEnt, NetGaming, Nolimit City, Novomatic, Nucleus, OnAir, OneTouch, Ortiz, Oryx, PariPlay, Peter&Sons, Platipus, Play'n GO, PlayPearls, Playson, Playtech, Pragmatic Play, Pragmatic Play Live, Push Gaming, Quickspin, Quik, Rabcat, Real Dealer Studios, Red Rake, Red Tiger, Relax Gaming, Revolver, Rogue, Ruby Play, Salsa Technology, Skywind, SlotMill, Smartsoft, SpadeGaming, Spinberry, Spinmatic, Spinomenal, Spribe, Stakelogic, Stormcraft Studios, Swintt, Switch Studios, Synot, Thunderkick, Tom Horn, Triple Edge Studios, Vibra Gaming, Wazdan, Woohoo Games, Yggdrasil, Zillion, Zitro";

const pros = [
  "Více než 9 000 her od špičkových poskytovatelů",
  "Pay N Play funkce pro rychlý přístup bez zdlouhavé registrace",
  "Vícejazyčná zákaznická podpora 24/7",
  "Štědrý uvítací bonus pro casino i sport",
  "Věrnostní prvky s \u201eBonus Crab\u201c",
];

const cons = [
  "Chybí mobilní aplikace",
  "Maximální měsíční limit pro výběr není veřejně uveden",
];

function TabContent({ activeTab }: { activeTab: string }) {
  const rowClass = "flex flex-col sm:flex-row sm:items-start gap-1 py-3 border-b border-[#eef1f7] last:border-0";
  const labelClass = "text-gray-500 text-sm sm:w-44 flex-shrink-0";
  const valueClass = "text-gray-900 text-sm font-medium leading-relaxed";

  if (activeTab === "platby") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Minimální vklad:</span><span className={valueClass}>250 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Minimální výběr:</span><span className={valueClass}>250 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Rychlost výplat:</span><span className={valueClass}>3 dny</span></div>
        <div className={rowClass}>
          <span className={labelClass}>Metody vkladu:</span>
          <span className={valueClass}>PlayID, Mastercard, Paysafecard, Skrill, Nuvei, Neteller, Jetonbank, MiFinity, USDTether TRC20, USDTether ERC20, USDTether BEP20, Bitcoin, Ethereum, Litecoin, Solana, BNB, Ripple, Bitcoin Cash, Dogecoin, Cardano</span>
        </div>
        <div className={rowClass}>
          <span className={labelClass}>Metody výběru:</span>
          <span className={valueClass}>PlayID, Visa, Mastercard, Bank Transfer, Revolut, Skrill, Nuvei, Neteller, Jetonbank, MiFinity, USDTether TRC20, USDTether ERC20, USDTether BEP20, Bitcoin, Ethereum, Litecoin, Solana, BNB, Ripple, Bitcoin Cash, Dogecoin, Cardano</span>
        </div>
      </div>
    );
  }
  if (activeTab === "hry") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Počet her:</span><span className={valueClass}>Více než 9 500 her</span></div>
        <div className={rowClass}><span className={labelClass}>Výherní automaty:</span><span className={valueClass}>Ano – různé žánry vč. megaways</span></div>
        <div className={rowClass}><span className={labelClass}>Živé stoly:</span><span className={valueClass}>Ano – ruleta, blackjack, baccarat, show</span></div>
        <div className={rowClass}><span className={labelClass}>Sportovní sázení:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>eSports:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Jackpotové hry:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Video poker:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Demo režim:</span><span className={valueClass}>Ano – dostupný u většiny slotů</span></div>
        <div className={rowClass}><span className={labelClass}>Poskytovatelé her:</span><span className={valueClass}>{providers}</span></div>
      </div>
    );
  }
  if (activeTab === "podpora") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Pracovní doba:</span><span className={valueClass}>Dostupné 24/7</span></div>
        <div className={rowClass}><span className={labelClass}>E-mail:</span><span className={valueClass}>support@bassbet.com</span></div>
        <div className={rowClass}><span className={labelClass}>Živý chat:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Telefonická podpora:</span><span className={valueClass}>Ne</span></div>
        <div className={rowClass}><span className={labelClass}>Provozovatel:</span><span className={valueClass}>Stellar Ltd</span></div>
        <div className={rowClass}><span className={labelClass}>Jazyky live chatu:</span><span className={valueClass}>Angličtina, Italština, Španělština a další</span></div>
      </div>
    );
  }
  if (activeTab === "obecne") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Web:</span><span className={valueClass}><a href="https://bassbet.com" target="_blank" rel="sponsored noopener noreferrer" className="text-[#003da5] hover:underline">bassbet.com</a></span></div>
        <div className={rowClass}><span className={labelClass}>Rok založení:</span><span className={valueClass}>2024</span></div>
        <div className={rowClass}><span className={labelClass}>Provozovatel:</span><span className={valueClass}>Stellar Ltd</span></div>
        <div className={rowClass}><span className={labelClass}>Licence:</span><span className={valueClass}>Anjouan (č. ALSI-202411077-F12)</span></div>
        <div className={rowClass}><span className={labelClass}>Jazyky:</span><span className={valueClass}>Angličtina, Němčina, Španělština, Finština, Francouzština, Maďarština, Norština, Polština, Portuguesa, Italština, Čeština a další</span></div>
        <div className={rowClass}><span className={labelClass}>Omezené země:</span><span className={valueClass}>Afghánistán, Bělorusko, Bulharsko, Curaçao, Kypr, Dánsko, Estonsko, Írán, Irák, Izrael, Litva, Malta, Moldavsko, Republika Pobřeží slonoviny, Rumunsko, Rusko, Severní Korea, Nizozemsko, Švédsko, Ukrajina, Spojené království, USA a další</span></div>
      </div>
    );
  }
  if (activeTab === "zodpovedne") {
    const items: [string, string][] = [
      ["Limit vkladu:", "Ano"],
      ["Limit sázek:", "Ano"],
      ["Limit ztrát:", "Ano"],
      ["Časový limit hraní:", "Ano"],
      ["Sebevyloučení:", "Ano"],
      ["Dočasná pauza:", "Ano"],
      ["Kontrola reality:", "Ne"],
      ["Sebehodnoticí test:", "Ne"],
      ["Blokace výběrů:", "Ne"],
      ["Demo režim (bez rizika):", "Ano"],
    ];
    return (
      <div className="divide-y divide-[#eef1f7]">
        {items.map(([label, value]) => (
          <div key={label} className={rowClass}>
            <span className={labelClass}>{label}</span>
            <span className={`${valueClass} ${value === "Ano" ? "text-green-600" : value === "Ne" ? "text-gray-400" : ""}`}>{value}</span>
          </div>
        ))}
      </div>
    );
  }
  return null;
}

export default function BassbetPage() {
  useSEO({ title: "BassBet Casino Recenze 2026 – Bonus a hodnocení | HrajBonus", description: "Nezávislá recenze BassBet Casino. Uvítací bonus, rozsáhlý výběr automatů a výhodné podmínky výplat. Zákaznická podpora v češtině. 18+",
  url: "https://hrajbonus.com/kasina/bassbet", });

  const [activeTab, setActiveTab] = useState("platby");
  const [showAllDeposit, setShowAllDeposit] = useState(false);
  const [showAllWithdrawal, setShowAllWithdrawal] = useState(false);

  const depositVisible = showAllDeposit ? depositMethods : depositMethods.slice(0, 10);
  const withdrawalVisible = showAllWithdrawal ? withdrawalMethods : withdrawalMethods.slice(0, 10);

  return (
    <>
      <Header />
      <main className="bg-[#f7f9fd] min-h-screen pt-[64px]">

        {/* ── Hero ─────────────────────────────────────────── */}
        <div style={{ background: "linear-gradient(135deg, #001a4d 0%, #002d7c 50%, #003da5 100%)" }}>
          <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-10 sm:py-14">
            <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">

              <div className="flex-1">
                <div className="flex items-center gap-6 mb-5">
                  <div className="w-[100px] h-[100px] rounded-xl flex-shrink-0 overflow-hidden shadow-lg">
                    <img src={logo4} alt="BassBet logo" className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="text-white/60 text-sm font-medium mb-0.5">Recenze kasina</div>
                    <h1 className="text-white font-bold text-2xl sm:text-3xl leading-tight">Kasina BassBet</h1>
                    <div className="text-white/50 text-xs mt-0.5">Aktualizováno: 15/02/2026</div>
                  </div>
                </div>

                <div className="flex items-center gap-2 mb-5">
                  <div className="flex gap-0.5">
                    {[1,2,3,4,5].map(i => (
                      <Star key={i} className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                    ))}
                  </div>
                  <span className="text-white font-bold text-xl">9.8</span>
                  <span className="text-white/50 text-sm">/10</span>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {[
                    { label: "Počet her",       value: "9 500+" },
                    { label: "Minimální vklad", value: "250 Kč" },
                    { label: "Minimální výběr", value: "250 Kč" },
                    { label: "Licence",         value: "Anjouan" },
                  ].map(s => (
                    <div key={s.label} className="bg-white/10 rounded-lg px-3 py-2.5 backdrop-blur-sm">
                      <div className="text-white/55 text-xs mb-0.5">{s.label}</div>
                      <div className="text-white font-bold text-sm">{s.value}</div>
                    </div>
                  ))}
                </div>

                <div className="mt-3 text-white/50 text-xs font-medium">
                  Přijímá hráče z České republiky
                </div>
              </div>

              <div className="lg:w-[320px] bg-white/10 border border-white/20 rounded-2xl p-6 backdrop-blur-sm">
                <div className="text-center mb-4">
                  <div className="text-white/70 text-sm mb-1">Uvítací bonus</div>
                  <div className="text-white font-black text-2xl leading-tight">až 12 500 Kč</div>
                  <div className="text-[#f5c518] font-bold text-lg">+ 200 Freespiny</div>
                </div>
                <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                  <Button
                    className="hraj-btn w-full font-bold text-base py-3 gap-2"
                    style={{ background: "#ffffff", color: "#003da5" }}
                    data-testid="button-hero-cta"
                  >
                    Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                  </Button>
                </a>
                <p className="text-white/40 text-xs text-center mt-3 leading-relaxed">
                  18+ | Zodpovědné hraní | Platí podmínky
                </p>
              </div>
            </div>
          </div>
        </div>

                <CasinoBreadcrumb casinoName="BassBet" />

<div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-8 sm:py-12">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">

            <div className="flex-1 min-w-0 space-y-8">

              {/* Author opinion */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-opinion">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0"><img src={mykhailoPhoto} alt="Mykhailo Romaenko" className="w-full h-full object-cover" /></div>
                  <div>
                    <div className="font-bold text-gray-900 text-sm">Mykhailo Romaenko</div>
                    <div className="text-gray-400 text-xs">Senior Content Writer</div>
                  </div>
                  <div className="ml-auto text-right">
                    <div className="text-[#003da5] font-black text-xl">9.8</div>
                    <div className="text-gray-400 text-xs">/10 hodnocení</div>
                  </div>
                </div>
                <h2 className="font-bold text-gray-900 text-base mb-2">Názory našich autorů</h2>
                <p className="text-gray-600 text-sm leading-relaxed">
                  BassBet je moderní platforma, která dokázala zohlednit požadavky dnešních hráčů. Tmavé modré rozhraní je příjemné pro oči, navigace intuitivní a katalog her patří k nejbohatším v oboru. Silnou stránkou je kombinace kasina a sportovního sázení pod jedním účtem, spolu s věrnostními prvky jako Bonus Crab.
                </p>

                <div className="grid sm:grid-cols-2 gap-4 mt-5">
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-green-700 text-xs uppercase tracking-wide mb-2">
                      <CheckCircle className="w-3.5 h-3.5" /> Výhody
                    </div>
                    <ul className="space-y-1.5">
                      {pros.map(p => (
                        <li key={p} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span> {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-red-600 text-xs uppercase tracking-wide mb-2">
                      <XCircle className="w-3.5 h-3.5" /> Nevýhody
                    </div>
                    <ul className="space-y-1.5">
                      {cons.map(c => (
                        <li key={c} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold mt-0.5 flex-shrink-0">▬</span> {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Tabs */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] shadow-sm overflow-hidden" data-testid="casino-overview-tabs">
                <div className="px-5 pt-5 pb-0 border-b border-[#eef1f7]">
                  <h2 className="font-bold text-gray-900 text-base mb-4">Přehled kasina</h2>
                  <div className="flex gap-0 overflow-x-auto scrollbar-hide -mx-5 px-5">
                    {tabs.map(tab => (
                      <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center gap-1.5 px-3 py-2.5 text-xs font-semibold whitespace-nowrap border-b-2 transition-colors flex-shrink-0 ${
                          activeTab === tab.id
                            ? "border-[#003da5] text-[#003da5]"
                            : "border-transparent text-gray-500 hover:text-gray-700"
                        }`}
                        data-testid={`tab-${tab.id}`}
                      >
                        <tab.icon className="w-3.5 h-3.5" />
                        {tab.label}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="p-5">
                  <TabContent activeTab={activeTab} />
                </div>
              </div>

              {/* Intro + overview */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-black text-gray-900 text-xl sm:text-2xl mb-4">
                  BassBet: Výhody pro férovou hru v Česku
                </h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  BassBet casino vstoupilo na trh v roce 2024 a rychle si získalo pozornost díky modernímu designu, přehledné navigaci a důrazu na pohodlí hráčů. Web cílí na evropské i latinskoamerické publikum, ale vítá hráče z celého světa. Velký důraz je kladen na sportovní sázky, výherní automaty a živé hry s krupiéry.
                </p>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Kasino funguje na základě licence ostrova Anjouan č. ALSI-202411077-F12, což potvrzuje jeho legálnost, férovost a bezpečnost. Herní lobby je pestré – od klasických slotů až po live casino. Nechybí ani bonusy pro nové i věrné hráče.
                </p>

                <div className="bg-[#f3f6fb] rounded-xl p-4 mb-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Co jsme testovali</div>
                  <div className="grid sm:grid-cols-2 gap-2">
                    {["Herní knihovna", "Bonusy & věrnostní program", "Platby & výběry", "Mobilní verze", "Zákaznická podpora"].map(item => (
                      <div key={item} className="flex items-center gap-2 text-gray-700 text-sm">
                        <CheckCircle className="w-4 h-4 text-[#003da5] flex-shrink-0" />
                        {item}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Why you'll like BassBet */}
                <h3 className="font-bold text-gray-900 text-base mb-3">Proč si BassBet oblíbíte</h3>
                <p className="text-gray-600 leading-relaxed mb-3">
                  Začátečníci ocení přehledné a intuitivní rozhraní. Registrace je otázkou minuty a většina slotů umožňuje sázky od 2,50 Kč. Skvělá volba pro bezpečný start v online casinu.
                </p>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Zkušení hráči ocení VIP stoly s vyššími limity a pokročilý systém sázek. Platforma je stabilní a nabízí rychlé výplaty i pravidelné turnaje s atraktivními výhrami. BassBet je tak ideální pro aktivní hráče, kteří hledají dynamiku a férové podmínky.
                </p>

                <a href="#bonusy">
                  <Button variant="outline" className="hraj-btn-light font-semibold gap-2 text-[#003da5]" data-testid="button-bonusy">
                    Přejít na bonusy <ArrowRight className="hraj-arrow w-4 h-4" />
                  </Button>
                </a>
              </div>

              {/* Games */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Jaké hry nabízí BassBet?</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  BassBet má rozsáhlé a vyvážené herní portfolio: výherní automaty různých žánrů, live casino, stolní hry, jackpotové automaty, virtuální sporty a sportovní sázky. Demo režim je dostupný u většiny slotů. Hry jsou rozděleny do kategorií, celkově jich najdete přes 7 000.
                </p>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Live casino sekce je propracovaná a přináší atmosféru skutečného kasina až k vám domů. Najdete zde desítky her a zábavných show, rychle se rozvíjející live sekci na úrovni slotů, stabilní chat s krupiéry v reálném čase a stoly s angličtinou, italštinou, španělštinou a dalšími jazyky. Hry od top providerů: Evolution Gaming, Ezugi, Pragmatic Play Live.
                </p>

                <div className="bg-[#f3f6fb] rounded-xl p-4">
                  <div className="font-bold text-gray-900 text-sm mb-3">Co v katalogu stojí za pozornost:</div>
                  <div className="space-y-2">
                    {[
                      "Přes 9 000 her – výherní automaty, live stoly, sport, eSports",
                      "Demo režim dostupný u většiny slotů bez nutnosti registrace",
                      "Live casino od Evolution Gaming, Ezugi a Pragmatic Play Live",
                      "Sportovní sázky a eSports pod jedním účtem",
                      "Jackpotové hry, video poker a stírací losy",
                    ].map(item => (
                      <div key={item} className="flex items-center gap-2 text-gray-700 text-sm">
                        <CheckCircle className="w-4 h-4 text-[#003da5] flex-shrink-0" />
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* UX + Mobile */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Grafika, rozhraní a mobilní hraní</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  BassBet působí moderně a přehledně. Web je laděný do tmavých modrých tónů s bílými prvky, což je příjemné pro oči. Rozhraní je čisté, prvky nejsou přeplácané, navigace je intuitivní jak na PC, tak na mobilu. Tlačítka jsou velká, text dobře čitelný a grafika kvalitní bez zbytečných rušivých detailů.
                </p>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Navigace je přátelská pro všechny typy hráčů. Hlavní sekce najdete v levém menu, uživatelský panel a finance jsou dostupné přes ikonu profilu vpravo nahoře. Rozhraní je rychlé, responzivní a dobře přizpůsobené mobilům. I začátečník rychle najde svou hru, pokročilí ocení filtry.
                </p>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Vlastní aplikace BassBet zatím nemá, ale mobilní verze webu to plně vynahrazuje. Vše běží v prohlížeči – není potřeba nic stahovat. Rozhraní je přizpůsobené dotykovým obrazovkám, načítání je rychlé a web funguje spolehlivě i při slabším internetu.
                </p>

                <div className="grid sm:grid-cols-2 gap-2">
                  {[
                    { q: "Padá mobilní verze často?", a: "Ne" },
                    { q: "Vyžaduje pravidelné aktualizace?", a: "Ne" },
                    { q: "Je navigace pohodlná pro palec?", a: "Ano" },
                    { q: "Musím si stáhnout aplikaci?", a: "Ne" },
                    { q: "Používá HTML5 místo Flashe?", a: "Ano" },
                    { q: "Jsou potíže s přístupem z mobilu?", a: "Ne" },
                  ].map(({ q, a }) => (
                    <div key={q} className="flex items-center justify-between gap-2 py-2 border-b border-[#eef1f7] last:border-0">
                      <span className="text-gray-600 text-xs">{q}</span>
                      <span className={`text-xs font-bold flex-shrink-0 ${a === "Ano" ? "text-green-600" : "text-gray-400"}`}>{a}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Bonuses */}
              <div id="bonusy" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Bonusy a promo akce BassBet</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  BassBet nabízí pestrý bonusový program: štědrý vstupní bonus, týdenní free spiny, weekend reload bonusy, cashback, turnaje a speciální funkce jako &bdquo;Bonus Crab&ldquo; a &bdquo;Rybářský turnaj&ldquo;. Díky tomu si zahrajete více za méně peněz.
                </p>

                <h3 className="font-bold text-gray-900 text-base mb-3">Co nabízí vstupní bonus BassBet?</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Noví hráči získají 100 % na první vklad až do 12 500 Kč + 200 free spinů + 1 Bonus Crab. Pro účast stačí zvolit bonus při registraci a vložit alespoň 500 Kč. Bonus je třeba protočit 35×, výhry z free spinů 40×. Akce platí 10 dní, free spiny dostáváte po 20 kusech denně.
                </p>

                <div className="bg-[#f3f6fb] rounded-xl p-4 mb-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Jak získat vstupní bonus BassBet?</div>
                  <ol className="space-y-1.5 text-gray-600 text-sm list-none">
                    {[
                      "Začněte registraci v kasinu.",
                      "Vyberte bonus pro sloty.",
                      "Dokončete registraci a vložte minimálně 500 Kč.",
                      "Bonusový balíček se připíše automaticky po připsání vkladu.",
                    ].map((step, i) => (
                      <li key={i} className="flex items-start gap-2">
                        <span className="text-[#003da5] font-bold flex-shrink-0">{i + 1}.</span> {step}
                      </li>
                    ))}
                  </ol>
                  <p className="text-gray-500 text-xs mt-3">Získání bonusu je rychlé a transparentní, není nutné zadávat promokód ani žádat podporu.</p>
                </div>

                <div className="mb-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Na co si dát pozor (typické podmínky)</div>
                  <ul className="space-y-2">
                    {[
                      "Požadavky na protočení: 35× bonus / 40× výhry z free spinů",
                      "Minimální vklad pro bonus: 500 Kč",
                      "Free spiny rozděleny do 10 balíčků po 20 kusech denně",
                      "Časová platnost akce: 10 dní od připsání bonusu",
                      "Příspěvky her: automaty 100 %, stolní hry méně, jackpoty se obvykle nepočítají",
                    ].map(item => (
                      <li key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                        <Trophy className="w-4 h-4 text-[#c9960f] mt-0.5 flex-shrink-0" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="bg-[#f0f5ff] border border-[#003da5]/15 rounded-xl p-4 mb-5">
                  <p className="text-gray-700 text-sm leading-relaxed">
                    <span className="font-bold text-[#003da5]">Nabízí BassBet bonus bez vkladu?</span> V době psaní recenze není na webu BassBet aktivní žádný bonus bez vkladu. Všechny akce vyžadují minimální vklad. V budoucnu se však může objevit v rámci speciálních promoakcí.
                  </p>
                </div>

                <h3 className="font-bold text-gray-900 text-base mb-3">Věrnostní program BassBet</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  BassBet nabízí jednoduchý, ale funkční věrnostní program. Za aktivitu (vklady, sázky, účast v akcích) sbíráte body, které lze vyměnit za free spiny, bonusy nebo exkluzivní dárky.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  Součástí programu jsou i VIP statusy. Ty přinášejí osobního manažera, rychlejší výplaty a individuální nabídky. Jakmile splníte podmínky, přechod na vyšší úroveň je automatický a s každým levelem rostou i vaše výhody.
                </p>
              </div>

              {/* Payments */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Platební metody BassBet</h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  BassBet spolupracuje pouze s důvěryhodnými a licencovanými platebními systémy. Možností pro vklad i výběr je dostatek – od karet, přes e-peněženky až po kryptoměny. Všechny platby jsou šifrované a probíhají přes zabezpečené kanály. Výběry trvají obvykle několik hodin až 2–3 dny podle zvolené metody. Kasino si neúčtuje poplatek za vklad ani výběr. Podporováno je několik měn včetně Kč a eura.
                </p>

                <div className="mb-5">
                  <div className="font-semibold text-gray-800 text-sm mb-2">Metody vkladu</div>
                  <div className="flex flex-wrap gap-1.5">
                    {depositVisible.map(m => (
                      <PaymentLogoPill key={m} name={m} />
                    ))}
                    {depositMethods.length > 10 && (
                      <button
                        onClick={() => setShowAllDeposit(!showAllDeposit)}
                        className="flex items-center gap-1 text-[#003da5] text-xs font-semibold hover:underline"
                      >
                        {showAllDeposit ? (<><ChevronUp className="w-3 h-3" /> méně</>) : (<><ChevronDown className="w-3 h-3" /> +{depositMethods.length - 10} dalších</>)}
                      </button>
                    )}
                  </div>
                </div>

                <div className="mb-6">
                  <div className="font-semibold text-gray-800 text-sm mb-2">Metody výběru</div>
                  <div className="flex flex-wrap gap-1.5">
                    {withdrawalVisible.map(m => (
                      <PaymentLogoPill key={m} name={m} />
                    ))}
                    {withdrawalMethods.length > 10 && (
                      <button
                        onClick={() => setShowAllWithdrawal(!showAllWithdrawal)}
                        className="flex items-center gap-1 text-[#003da5] text-xs font-semibold hover:underline"
                      >
                        {showAllWithdrawal ? (<><ChevronUp className="w-3 h-3" /> méně</>) : (<><ChevronDown className="w-3 h-3" /> +{withdrawalMethods.length - 10} dalších</>)}
                      </button>
                    )}
                  </div>
                </div>

                <div className="overflow-x-auto rounded-xl border border-[#dde4ee]">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-[#f3f6fb]">
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Metoda</th>
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Odeslání výhry</th>
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Poplatek ze strany kasina</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        ["E-peněženky (Skrill, Neteller)", "několik hodin", "ne"],
                        ["Platební karta", "1–3 pracovní dny", "ne"],
                        ["Bankovní převod", "2–5 pracovních dní", "ne"],
                        ["Kryptoměny", "téměř okamžitě po schválení", "ne"],
                      ].map(([method, speed, fee], i) => (
                        <tr key={i} className="border-t border-[#eef1f7]">
                          <td className="px-4 py-3 font-medium text-gray-900">{method}</td>
                          <td className="px-4 py-3 text-gray-600">{speed}</td>
                          <td className="px-4 py-3 text-gray-400">{fee}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Customer support */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Zákaznická podpora 24/7</h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  BassBet zajišťuje vícejazyčnou zákaznickou podporu nonstop přes live chat i e-mail. Live chat reaguje rychle, e-mail je vhodný pro složitější požadavky. Telefonická linka k dispozici není.
                </p>

                <div className="grid sm:grid-cols-3 gap-3">
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <MessageCircle className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">Live chat</div>
                      <div className="text-green-600 text-xs">24/7, rychlé reakce</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <Mail className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">E-mail</div>
                      <div className="text-green-600 text-xs">support@bassbet.com</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-gray-50 border border-gray-200 rounded-xl">
                    <HeadphonesIcon className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-700 text-sm">Telefon</div>
                      <div className="text-gray-400 text-xs">není k dispozici</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Safety */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Bezpečnost a férová hra</h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Kasino funguje na základě licence ostrova Anjouan č. ALSI-202411077-F12, která potvrzuje jeho legálnost, férovost a bezpečnost. Hry pocházejí od certifikovaných studií s ověřeným RNG. Bezpečnostní infrastruktura zahrnuje 256bitové SSL šifrování.
                </p>
                <div className="grid sm:grid-cols-2 gap-2">
                  {[
                    "Licence Anjouan – ověřená férovost a bezpečnost",
                    "256bitové SSL šifrování všech transakcí",
                    "Hry od certifikovaných studií s ověřeným RNG",
                    "Limity vkladů, sázek a ztrát pro odpovědné hraní",
                    "Možnost sebevyloučení a dočasné pauzy",
                    "Demo režim – vyzkoušejte hry bez rizika",
                  ].map(item => (
                    <div key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                      <ShieldCheck className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>
              </div>

              {/* Pros/Cons final */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-5">Výhody a nevýhody BassBet v kostce</h2>
                <div className="grid sm:grid-cols-2 gap-6">
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-green-700 text-sm uppercase tracking-wide mb-3">
                      <CheckCircle className="w-4 h-4" /> Výhody
                    </div>
                    <ul className="space-y-2">
                      {pros.map(p => (
                        <li key={p} className="flex items-start gap-2 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold text-base leading-none mt-0.5 flex-shrink-0">+</span> {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-red-600 text-sm uppercase tracking-wide mb-3">
                      <XCircle className="w-4 h-4" /> Nevýhody
                    </div>
                    <ul className="space-y-2">
                      {cons.map(c => (
                        <li key={c} className="flex items-start gap-2 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold text-base leading-none mt-0.5 flex-shrink-0">▬</span> {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <p className="text-gray-500 text-sm mt-5 leading-relaxed">
                  Obě nevýhody jsou spíše drobné, zejména s ohledem na vysokou úroveň bezpečnosti a férovosti platformy. Mobilní verze webu plně nahrazuje chybějící aplikaci a výběrové limity jsou v profilu dostupné po přihlášení.
                </p>
              </div>

              {/* Jak se zaregistrovat */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Jak se registrovat v BassBet</h2>
                <p className="text-gray-600 leading-relaxed mb-4">Registrace je rychlá a jednoduchá:</p>
                <div className="space-y-2.5 mb-5">
                  {[
                    "Navštivte oficiální web kasina.",
                    "Klikněte na \u201eRegistrace\u201c.",
                    "Vyberte typ bonusu pro nové hráče.",
                    "Zadejte e-mail a heslo.",
                    "Potvrďte věk 18+ a souhlas s pravidly.",
                    "Dokončete registraci.",
                  ].map((step, i) => (
                    <div key={i} className="flex items-start gap-2.5 text-gray-700 text-sm">
                      <span className="text-[#003da5] font-bold flex-shrink-0">{i + 1}.</span> {step}
                    </div>
                  ))}
                </div>
                <p className="text-gray-500 text-sm leading-relaxed">
                  Po vytvoření účtu je třeba projít ověřením identity – není nutné hned, ale bez něj nelze vybírat výhry.
                </p>
              </div>

              {/* Conclusion */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <p className="text-gray-700 leading-relaxed">
                  BassBet patří v roce 2026 mezi solidní výběr pro hráče, kteří hledají bohaté herní portfolio, férové bonusy a kombinaci kasina se sportovním sázením pod jedním účtem. Věrnostní prvky jako Bonus Crab přidávají hravý rozměr, který odlišuje platformu od bezejmenné konkurence.
                </p>
              </div>

              {/* Author bio */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-bio">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0 ring-4 ring-[#003da5]/10"><img src={mykhailoPhoto} alt="Mykhailo Romaenko" className="w-full h-full object-cover" /></div>
                  <div>
                    <div className="font-bold text-gray-900">Mykhailo Romaenko</div>
                    <div className="text-[#003da5] text-sm font-medium">Senior Content Writer</div>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Mykhailo je zkušený autor zaměřený na iGaming, který se dlouhodobě pohybuje v odvětví online hazardu. Má bohatou praxi v psaní článků, které propojují svět hráčů i profesionálů. Jeho specialitou je vytváření hlubokých analýz, přehledných recenzí a trendově orientovaného obsahu, který čtenářům přináší nejen zábavu, ale i znalosti.
                </p>
                <p className="text-gray-600 text-sm leading-relaxed mt-3">
                  Své texty staví na detailním výzkumu a praktické zkušenosti, díky čemuž pomáhá hráčům lépe se orientovat v prostředí online casin.
                </p>
              </div>

            </div>

            {/* ── Sticky sidebar ────────────────────────────── */}
            <aside className="lg:w-[300px] flex-shrink-0">
              <div className="lg:sticky lg:top-[84px] space-y-4">

                <div className="bg-white rounded-2xl border border-[#003da5]/25 shadow-[0_4px_24px_rgba(0,61,165,0.12)] p-5" data-testid="sidebar-cta">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-lg bg-[#f3f6fb] flex items-center justify-center overflow-hidden">
                      <img src={logo4} alt="BassBet" className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <div className="font-bold text-gray-900 text-sm">BassBet</div>
                      <div className="flex items-center gap-1">
                        {[1,2,3,4,5].map(i => <Star key={i} className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />)}
                        <span className="text-gray-600 text-xs ml-1">9.8/10</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mb-4 bg-[#f3f6fb] rounded-xl py-3">
                    <div className="text-gray-500 text-xs mb-0.5">Uvítací bonus</div>
                    <div className="text-[#003da5] font-black text-xl">až 12 500 Kč</div>
                    <div className="text-[#c9960f] font-bold text-sm">+ 200 Freespiny</div>
                  </div>
                  <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                    <Button
                      className="hraj-btn w-full font-bold gap-2"
                      style={{ background: "#003da5" }}
                      data-testid="button-sidebar-cta"
                    >
                      Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                    </Button>
                  </a>
                  <p className="text-gray-400 text-xs text-center mt-2">18+ | Platí podmínky</p>
                </div>

                <div className="bg-white rounded-2xl border border-[#dde4ee] p-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Rychlý přehled</div>
                  <div className="space-y-2.5">
                    {([
                      { icon: Globe,      label: "Web",          value: "bassbet.com" },
                      { icon: Calendar,   label: "Rok",          value: "2024" },
                      { icon: Lock,       label: "Licence",      value: "Anjouan" },
                      { icon: Users,      label: "Provozovatel", value: "Stellar Ltd" },
                      { icon: Gamepad2,   label: "Počet her",    value: "9 500+" },
                      { icon: Clock,      label: "Podpora",      value: "24/7 Live chat" },
                      { icon: CreditCard, label: "Min. vklad",   value: "250 Kč" },
                      { icon: Zap,        label: "Výplaty",      value: "Několik hodin (e-wallet)" },
                    ] as const).map(({ icon: Icon, label, value }) => (
                      <div key={label} className="flex items-start gap-2">
                        <Icon className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                        <div className="min-w-0">
                          <span className="text-gray-400 text-xs">{label}: </span>
                          <span className="text-gray-800 font-medium text-xs">{value}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

              </div>
            </aside>

          </div>
        </div>
      </main>
      
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 pb-8">
          <DalsiRecenze currentSlug="bassbet" />
        </div>

  
        {/* Related reviews */}
        <div className="max-w-[900px] mx-auto px-4 py-4">
          <p className="text-sm text-gray-500 leading-relaxed text-center">
            <span className="font-semibold text-gray-700">Podobná kasina: </span>
              <a href="/kasina/bankonbet" className="text-[#003da5] hover:underline" data-testid="review-link-bankonbet">Bankonbet</a>
              {" · "}
              <a href="/kasina/rabona" className="text-[#003da5] hover:underline" data-testid="review-link-rabona">Rabona</a>
              {" · "}
              <a href="/kasina/spinanga" className="text-[#003da5] hover:underline" data-testid="review-link-spinanga">Spinanga</a>
            {" · "}
            <a href="/kasina" className="text-[#003da5] hover:underline font-semibold" data-testid="review-link-vsechna">Všechna kasina</a>
            {" · "}
            <a href="/porovnat" className="text-[#003da5] hover:underline" data-testid="review-link-porovnat">Porovnání</a>
          </p>
        </div>
      <Footer />
    </>
  );
}
